import { SxProps } from '@mui/material'
import { COLORS } from '@/styles'

interface WarningBoxStyles {
  warning: SxProps
}

export const warningBoxStyles: WarningBoxStyles = {
  warning: {
    p: 1,
    mt: 0.75,
    borderRadius: 2,
    typography: 'textSm',
    color: COLORS.AMBER_DARK,
    backgroundColor: COLORS.CREAM_LIGHT,
  },
}
